import React from 'react';
import { Link } from "react-router-dom";
import "./NotFound.scss";

const NotFound = ({ data, language }) => {
  // Fallback messages in Mongolian (as per workspace rules)
  const fallbackData = {
    title: "404",
    heading: "Хуудас олдсонгүй",
    message: "Уучлаарай, таны хайж буй хуудас олдсонгүй эсвэл шилжүүлсэн байна.",
    homeButton: "Нүүр хуудас руу буцах"
  };

  // data is already the NotFound object from App.jsx
  const notFoundData = data || fallbackData;

  return (
    <section className="not-found-container">
      <div className="not-found-content">
        <div className="error-code">{notFoundData.title}</div>
        <h1 className="error-heading">{notFoundData.heading}</h1>
        <p className="error-message">{notFoundData.message}</p>
        <Link to="/" className="home-button">
          {notFoundData.homeButton}
        </Link>
      </div>
      <div className="illustration">🔍</div>
    </section>
  );
};

export default NotFound;
